import React, { useContext } from 'react'
import Login from '../../components/login/login'
import { DataContext } from '../../app/data-context'
import ProgramView from './program-view'

const Program: React.FC = () => {
  const { context } = useContext(DataContext);

  return !context?.group ? <Login /> : <ProgramView />
}

export default Program
